import { useState, useEffect } from 'react';
import { colors, screen } from 'components/styles/variables';
import classNames from 'classnames';

import ColorCheck from 'public/static/images/srp/ColorSelectors/ColorCheck.svg';
import Black from 'public/static/images/srp/ColorSelectors/Black.svg';
import White from 'public/static/images/srp/ColorSelectors/White.svg';
import Gray from 'public/static/images/srp/ColorSelectors/Gray.svg';
import Yellow from 'public/static/images/srp/ColorSelectors/Yellow.svg';
import Orange from 'public/static/images/srp/ColorSelectors/Orange.svg';
import Brown from 'public/static/images/srp/ColorSelectors/Brown.svg';
import Red from 'public/static/images/srp/ColorSelectors/Red.svg';
import Green from 'public/static/images/srp/ColorSelectors/Green.svg';
import Blue from 'public/static/images/srp/ColorSelectors/Blue.svg';
import Purple from 'public/static/images/srp/ColorSelectors/Purple.svg';
import Silver from 'public/static/images/srp/ColorSelectors/Silver.svg';
import Gold from 'public/static/images/srp/ColorSelectors/Gold.svg';

export interface ColorSelectorProps {
  onClick(isActive: boolean): void;
  active?: boolean;
  color: string;
  qualifier?: string;
}

const circleColors: { [key: string]: string } = {
  Black,
  Red,
  White,
  Gray,
  Yellow,
  Orange,
  Brown,
  Green,
  Blue,
  Purple,
  Silver,
  Gold,
};

export default function ColorSelector({
  active = false,
  color,
  onClick,
  qualifier = '',
}: ColorSelectorProps): JSX.Element {
  const [isActive, setIsActive] = useState(active);
  useEffect(() => {
    setIsActive(active);
  }, [active]);

  function handleClick(): void {
    setIsActive((prev) => !prev);
    onClick(isActive);
  }

  const labelId = `${color}-color-label-${qualifier}`;

  return (
    <div className="color-selector-container">
      <button
        className={classNames(
          'color-selector',
          'checkmark-container',
          `${isActive ? 'active' : 'inactive'}`
        )}
        onClick={handleClick}
        aria-labelledby={labelId}
      >
        {active && (
          <img
            alt="active-color"
            src={ColorCheck}
            role="presentation"
            className="active-checkmark"
          />
        )}
      </button>
      <label id={labelId} className="color-label">
        {color}
      </label>
      <style jsx>{`
        .color-selector-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 50px;
          height: 64px;
        }

        .color-selector {
          height: 39px;
          width: 39px;
          border: none;
          background-size: cover;
          background-image: url(${circleColors[color]});
          border-radius: 25px;
          cursor: pointer;
          background-color: white;
        }

        .active {
          border: 2px solid ${colors.BLACK};
        }

        .checkmark-container {
          position: relative;
        }

        .active-checkmark {
          position: absolute;
          top: 6px;
          left: 5px;
          width: 26px;
        }

        .color-label {
          margin-top: 5px;
          font-size: 12px;
          line-height: 16px;
          color: ${colors.BLACK};
          letter-spacing: 0.2px;
        }

        @media (min-width: ${screen.smMin}) {
          .color-selector:hover {
            border: 2px solid ${colors.G2};
          }
        }
      `}</style>
    </div>
  );
}
